import { getOnContent } from '@/common/converter/utils/get-event-property'
import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'on-content'
 * @param elementList
 * @returns {{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined}
 */
export const convertEventOnContent = (elementList = []) => {
  const { type, url, bodyList, method, isRender } = getOnContent(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
